import { render, staticRenderFns } from "./M_loginSecuritySettings.vue?vue&type=template&id=70b247fc&scoped=true&"
import script from "./M_loginSecuritySettings.vue?vue&type=script&lang=js&"
export * from "./M_loginSecuritySettings.vue?vue&type=script&lang=js&"
import style0 from "./M_loginSecuritySettings.vue?vue&type=style&index=0&id=70b247fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b247fc",
  null
  
)

export default component.exports